import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("circle", {
  cx: "12",
  cy: "12",
  r: "5"
}), ___EmotionJSX("line", {
  x1: "12",
  y1: "1",
  x2: "12",
  y2: "3"
}), ___EmotionJSX("line", {
  x1: "12",
  y1: "21",
  x2: "12",
  y2: "23"
}), ___EmotionJSX("line", {
  x1: "4.22",
  y1: "4.22",
  x2: "5.64",
  y2: "5.64"
}), ___EmotionJSX("line", {
  x1: "18.36",
  y1: "18.36",
  x2: "19.78",
  y2: "19.78"
}), ___EmotionJSX("line", {
  x1: "1",
  y1: "12",
  x2: "3",
  y2: "12"
}), ___EmotionJSX("line", {
  x1: "21",
  y1: "12",
  x2: "23",
  y2: "12"
}), ___EmotionJSX("line", {
  x1: "4.22",
  y1: "19.78",
  x2: "5.64",
  y2: "18.36"
}), ___EmotionJSX("line", {
  x1: "18.36",
  y1: "5.64",
  x2: "19.78",
  y2: "4.22"
}));
export default SVG;